import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CreditInvoiceReportData} from "./credit-invoice-report.data";

@Injectable()
export class CreditInvoiceReportModel extends ReportModel<CreditInvoiceReportData> {
    constructor(injector: Injector) {
        super(injector, CreditInvoiceReportData)
    }
}
